import React from 'react';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import {
    Typography,
	Button,
	CssBaseline,
	Grid,
	Container
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TextInput from '../ui_components/text_input';
import { addUserPassword } from '../../store/actions/user/user_action';
import { useParams } from 'react-router-dom';
import history from '../../services/history';
import { REACT_ROUTES } from '../../constants/react_routes';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
        '& > p': {
            color: '#bf1650',
            '&::before': {
                display: 'inline',
                content: '"⚠ "'
            }
        }
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},
    link: {
        color: '#64b5f6',
        '&:hover': {
            color: '#53a3df'
        }
    }
}));

const AddUserPassword = () => {
    const { token } = useParams();

    const { paper, form, submit } = useStyles();
    const { control, handleSubmit, getValues, formState: { errors } } = useForm();
    const { enqueueSnackbar } = useSnackbar();

    const onSubmit = async (data) => {
        const { message } = await addUserPassword(token, data);
        if (message) {
            return enqueueSnackbar(
                message, {
                variant: 'warning'
            });
        }
        enqueueSnackbar(
            'Uspešno ste uneli lozinku', {
            variant: 'success'
        });
        return history.push(REACT_ROUTES.HOME);
    };

	return (
		<Container component="main" maxWidth="xs">
			<CssBaseline />
			<Grid className={paper}>
				<Typography component="h1" variant="h5">
					Kreirajte lozinku
				</Typography>
				<form onSubmit={handleSubmit(onSubmit)} className={form}>
					<TextInput
						name="password"
						label="Lozinka"
                        control={control}
                        type="password"
                        rules={{
                            required: "Unesite lozinku",
                            minLength: {
                                value: 6,
                                message: "Lozinka mora imati najmanje 6 karaktera"
                            }
                        }}
					/>
                    <ErrorMessage errors={errors} name="password" as="p" />
					<TextInput
						name="confirmPassword"
						label="Potvrdite lozinku"
                        type="password"
                        control={control}
                        rules={{
                            required: "Potvrdite lozinku",
                            validate: value => (
                                value === getValues('password') || 'Lozinke se moraju poklapati'
                            )
                        }}
					/>
                    <ErrorMessage errors={errors} name="confirmPassword" as="p" />
					<Button
						className={submit}
						type="submit"
						variant="contained"
						color="primary"
						fullWidth
					>
						Kreirajte lozinku
					</Button>
				</form>
			</Grid>
		</Container>
	);
}

export default AddUserPassword;

